var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.091,
    height: 16.091,
    viewBox: "0 0 16.091 16.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Time_1888079",
    transform: "translate(-21 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(21 21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M29.046,973.362a8.046,8.046,0,1,0,8.046,8.046A8.058,8.058,0,0,0,29.046,973.362Zm0,1.665a6.381,6.381,0,1,1-6.381,6.381A6.369,6.369,0,0,1,29.046,975.027Zm0,1.387a.832.832,0,0,0-.832.832v4.162a.831.831,0,0,0,.243.589l2.549,2.549a.834.834,0,0,0,1.179-1.179l-2.306-2.306v-3.815A.832.832,0,0,0,29.046,976.414Z",
    transform: "translate(-21 -973.362)",
    fill: "#919191"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.07954be457d44ae65819eb7530c31cfb.svg";
export { ForwardRef as ReactComponent };